import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	.collapse {
		position: relative;
		height: 0;
		overflow: hidden;
		transition: height 0.5s ease;
	}

	.collapse.show {
		height: auto;
	}
`;

export const Header = styled.header`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 40px;
	padding: 0 10px 0 20px;
	border-bottom: 1px solid #d8dee6;
	margin-bottom: 10px;
	margin-right: 10px;
	color: ${tokens.color_gray_dark};
	cursor: pointer;
`;

export const UnorderedList = styled.ul`
	display: grid;
	gap: 6px;
	grid-gap: 6px;
	margin: 10px 0 15px 0;
`;

export const ListItem = styled.li`
	padding-left: 48px;
	font-weight: 600;
	color: ${tokens.color_gray_dark};

	&:before {
		content: '•';
		padding-right: 8px;
		font-size: 24px;
		font-weight: 600;
		color: ${tokens.color_gray_dark};
	}
`;

export const Title = styled.h2`
	margin: 0;
	font-size: 14px;
	font-weight: 500;
`;

export const ChevronIcon = styled.span<{ opened?: boolean }>`
	transition: 0.3s;
	transform: ${({ opened }) => (opened ? 'rotate(180deg)' : 'rotate(0deg)')};
`;
